import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { RootState } from 'src/store/store'

// Define a custom hook with a specific type
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
